import { Capacitor } from "@capacitor/core";
import { useNavigate } from "react-router-dom";

import { TextButton } from "@/atoms/text-button/TextButton";
import { useFeatureFlag } from "services/Flags";

type AnonymousLoginProps = {
  /** Whether the current user is already authorized */
  isAuthorized?: boolean;
  /** Optional override for the trailing icon */
  /** Whether to render with extra-small text sizing */
  xsText?: boolean;
  /** Optional class names for positioning/styling */
  className?: string;
};

export const AnonymousLogin = ({
  isAuthorized = false,
  xsText = true,
  className,
}: AnonymousLoginProps) => {
  const navigate = useNavigate();
  const guestAccessFlag = useFeatureFlag("guestAccess");
  const comingFromDeepLink = window.localStorage.getItem("platformId");

  const shouldShow =
    guestAccessFlag ||
    isAuthorized ||
    (Capacitor.isNativePlatform() && !comingFromDeepLink);

  if (!shouldShow) return null;

  return (
    <TextButton
      xsText={xsText}
      className={className}
      onClick={() => navigate("/signin/location")}
    >
      {isAuthorized ? "Find a different location" : "Skip login for now"}
    </TextButton>
  );
};
